import axios from 'axios';

const configuredApiUrl = String(
  process.env.REACT_APP_API_URL || ''
).trim().replace(/\/+$/, '');

const isLocalBrowser =
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1';

const baseURL =
  configuredApiUrl ||
  (isLocalBrowser ? 'http://localhost:5000/api' : '/api');

if (!configuredApiUrl && !isLocalBrowser) {
  console.warn(
    'REACT_APP_API_URL belum diatur. Tambahkan URL Worker pada Environment Variables Cloudflare Pages.'
  );
}

const client = axios.create({
  baseURL,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  },
});

client.interceptors.request.use((config) => {
  const token = localStorage.getItem('uniloot_token');

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response?.status === 401 &&
      localStorage.getItem('uniloot_token')
    ) {
      localStorage.removeItem('uniloot_token');
      localStorage.removeItem('uniloot_user');
    }

    return Promise.reject(error);
  }
);

export default client;
